import { query } from '@confluence/query-preloader-tools/entry-points/graphql';

import { ThemeQuery } from './ThemeQuery.graphql';

export function preloadPageLayout() {
	return query({
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		query: ThemeQuery,
	});
}
